import { Accordion, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";

/* eslint-disable @typescript-eslint/no-explicit-any */
const DetailSection = ({ title, children }: any) => {
  let showChevron = children != null;
  if (Array.isArray(children)) {
    showChevron = children.length > 0;
  }

  return (
    <Accordion
      variant="separated"
      defaultValue={title}
      radius={10}
      mb={10}
      mx={10}
      className="case-detail-section"
      classNames={{ chevron: "chevron" }}
      chevron={showChevron && <IconChevronDown width={20} height={20} />}
    >
      <Accordion.Item key={title} value={title}>
        <Accordion.Control>
          <Text fz={16} fw={500}>
            {title}
          </Text>
        </Accordion.Control>
        {showChevron && <Accordion.Panel>{children}</Accordion.Panel>}
      </Accordion.Item>
    </Accordion>
  );
};
export default DetailSection;
